import React from "react";
import logo from "../../assets/images/logo.png";
import InstagramIcon from "../../assets/images/instagramIcon.svg";
import LinkedInIcon from "../../assets/images/linkedInIcon.svg";
import YouTubeIcon from "../../assets/images/youtubeIcon.svg";
import TwitterIcon from "../../assets/images/twitterIcon.svg";
import "./maintenance.scss";

const MaintenancePage = ({
    message = "We're tuning things up behind the scenes to make Ample Samples™  better. Your account, crates and licenses are safe.",
}) => {
    return (
        <main className="maintenance">
            <img className="maintenance__logo" src={logo} alt="Ample Samples™"/>
            <div className="maintenance__content">
                <span className="maintenance__status">
                    <span className="maintenance__dot" aria-hidden="true"/>
                    Scheduled maintenance
                </span>
                <h1 className="maintenance__title">
                    We'll be back <span>shortly</span>
                </h1>
                <p className="maintenance__message">{message}</p>
            </div>
            <footer className="maintenance__footer">
                <a href="https://www.instagram.com/theamplesamples?igsh=NTc4MTIwNjQ2YQ==" target="_blank" rel="noopener noreferrer">
                    <img src={InstagramIcon} alt="Instagram"/>
                </a>
                <a href="https://www.linkedin.com/in/ample-samples%E2%84%A2-28b253160?" target="_blank" rel="noopener noreferrer">
                    <img src={LinkedInIcon} alt="LinkedIn"/>
                </a>
                <a href="https://youtube.com/@theamplesamples?si=3m3.3_xHUFBXh_j1V3" target="_blank" rel="noopener noreferrer">
                    <img src={YouTubeIcon} alt="YouTube"/>
                </a>
                <a href="https://x.com/theamplesamples" target="_blank" rel="noopener noreferrer">
                    <img src={TwitterIcon} alt="X (Twitter)"/>
                </a>
            </footer>
        </main>
    );
};

export default MaintenancePage;
